import { apiConfig } from '../api-config';

export const getAppointment = async (params: any) => {
  return apiConfig
    .get(`/api/appointments/get-by-id-agent-id-territory?agentId=${params.agentId}&territoryId=${params.cdTerritory}&tokenKey=${params.tokenKey}`)
    .then((resp) => resp.data.objectResult || [])
    .catch((err) => ({ hasErrors: true, err }));
};
